import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import GridContainer from './GridContainer';
import GridContents from './GridContents';
import GridContentsTabState from './GridContentsTabState';

export default class GridContentsTabView extends BufferTabView<GridContentsTabState> {
  static override initClass(): void {
    this.prototype.className = 'buffer-tab buffer-tab--no-padding';
  }

  override render(): GridContentsTabView {
    renderToDOM(
      <GridContainer gridId={this.model.get('gridId')}>
        {(childProps) => <GridContents {...childProps} />}
      </GridContainer>,
      this.el
    );
    return this;
  }

  override remove(): GridContentsTabView {
    ReactDOM.unmountComponentAtNode(this.el);
    super.remove();
    return this;
  }
}
